module.exports = "<div cdk-overlay-origin style=\"position: relative;\"></div>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Work/Projects/OnlineParser/web2-ui/src/app/helper/info-text/info-text.component.html
// module id = ../../../../../src/app/helper/info-text/info-text.component.html
// module chunks = main